// Locale + currency: real Shopify Markets localization form. Each
// <select data-gn-locale-select> lives inside its own {% form 'localization' %};
// changing it submits that form so Shopify updates the country (currency) or language.
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-gn-locale-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      if (select.form) select.form.submit();
    });
  });

  initPageLoader();
  initHeaderSearch();
  initCountdowns();
  initCatsGsap();
  initBrandsMarquee();
  initReviewsMarquee();
  initProductFilters();
  initProductSort();
  initAuthModalAutoShow();
  initPasswordConfirmCheck();
  initPdpGallery();
  initPdpOptions();
  initPdpAddToCart();
  initProductCardAddToCart();
  initPdpQty();
  initCartPage();
  initPayMethods();
  initPayForm();
  initAuthModals();
  initOrderCancel();
  initOrderReceive();
  initProfilePassword();
  initFloatTop();
  initFloatToggle();
  initProfileAvatar();
  initAddressCountrySelect();
  initAddressForms();
});

// Customer address form: pre-select the address's current country in the
// <select> built from all_country_option_tags (that object has no notion
// of "currently selected", unlike form.country_option_tags).
function initAddressCountrySelect() {
  document.querySelectorAll('select[data-current-country]').forEach(function (select) {
    var current = select.getAttribute('data-current-country');
    if (!current) return;
    select.value = current;
    if (select.value === current) return;
    // Exact match failed (case/whitespace/accent difference) — retry loosely.
    var target = current.trim().toLowerCase();
    var options = select.querySelectorAll('option');
    for (var i = 0; i < options.length; i++) {
      var opt = options[i];
      if (opt.value.trim().toLowerCase() === target || opt.textContent.trim().toLowerCase() === target) {
        select.value = opt.value;
        break;
      }
    }
  });
}

// Customer address add/edit/delete: under New Customer Accounts, Shopify's
// account backend redirects every customer_address submission to the
// hosted shopify.com account overview, ignoring the `return_to` param
// entirely (confirmed: even syntactically-correct return_to on
// create/update is ignored, not just delete). Submit every one of these
// forms via fetch instead (redirect: 'manual' so the cross-domain redirect
// isn't followed) and reload this page ourselves so the user always stays
// on /pages/dia-chi.
function initAddressForms() {
  document.querySelectorAll('[data-address-ajax-submit]').forEach(function (btn) {
    var form = btn.closest('form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      btn.disabled = true;
      var formData = new FormData(form);
      var method = (btn.getAttribute('data-address-ajax-method') || 'POST').toUpperCase();
      fetch(form.action, {
        method: method,
        body: formData,
        redirect: 'manual',
        credentials: 'same-origin'
      })
        .then(function (res) {
          console.log('[gn-address-form] fetch resolved', { method: method, type: res.type, status: res.status, url: form.action });
          window.location.reload();
        })
        .catch(function (err) {
          console.error('[gn-address-form] fetch failed', err, { method: method, url: form.action });
          btn.disabled = false;
          window.location.reload();
        });
    });
  });
}

/** Focus search input when search offcanvas opens; wire keyword tags */
function initHeaderSearch() {
  var panel = document.getElementById('gn-search-offcanvas');
  if (!panel) return;

  panel.addEventListener('shown.bs.offcanvas', function () {
    var input = panel.querySelector('#gn-search-offcanvas-input');
    if (input) input.focus();
  });

  panel.querySelectorAll('[data-search-tag]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = panel.querySelector('#gn-search-offcanvas-input');
      var tag = btn.getAttribute('data-search-tag') || '';
      if (!input || !tag) return;
      input.value = tag;
      input.focus();
    });
  });
}

/** Page-change overlay — ~1s cover while HTML/CSS catch up */
function initPageLoader() {
  var el = document.getElementById('gn-page-loader');
  if (!el) return;

  var hideTimer = 0;

  function show() {
    clearTimeout(hideTimer);
    el.classList.remove('is-hidden');
    el.setAttribute('aria-busy', 'true');
  }

  function hide() {
    el.classList.add('is-hidden');
    el.setAttribute('aria-busy', 'false');
  }

  hideTimer = setTimeout(hide, 1000);

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) hide();
  });

  document.addEventListener(
    'click',
    function (e) {
      if (e.defaultPrevented) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      var a = e.target.closest('a[href]');
      if (!a) return;
      if (a.target && a.target !== '_self') return;
      if (a.hasAttribute('download') || a.hasAttribute('data-bs-toggle') || a.hasAttribute('data-bs-dismiss')) return;
      var href = a.getAttribute('href') || '';
      if (!href || href === '#' || href.indexOf('#') === 0 || href.indexOf('javascript:') === 0) return;
      try {
        var url = new URL(a.href, window.location.href);
        if (url.origin !== window.location.origin) return;
        if (url.pathname === window.location.pathname && url.search === window.location.search) return;
      } catch (err) {
        return;
      }
      show();
    },
    true
  );
}

/** Profile change-password form: required + match */
function initProfilePassword() {
  var form = document.getElementById('gn-profile-password-form');
  var V = window.GnValidate;
  if (!form || !V) return;

  V.bindFieldClear(form);
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!V.validateForm(form)) return;

    var pw = document.getElementById('gn-profile-new-password');
    var confirm = document.getElementById('gn-profile-confirm-password');
    if (pw && confirm && pw.value !== confirm.value) {
      V.setFieldError(confirm, 'Mật khẩu xác nhận không khớp');
      confirm.focus();
    }
  });
}

/** Order detail: confirm cancel → success modal */
function initOrderCancel() {
  var askEl = document.getElementById('gn-modal-cancel-order');
  var doneEl = document.getElementById('gn-modal-cancel-done');
  var confirmBtn = document.querySelector('.js-order-cancel-confirm');
  if (!askEl || !doneEl || !confirmBtn || !window.bootstrap) return;

  confirmBtn.addEventListener('click', function () {
    askEl.addEventListener(
      'hidden.bs.modal',
      function () {
        bootstrap.Modal.getOrCreateInstance(doneEl).show();
      },
      { once: true }
    );
    bootstrap.Modal.getOrCreateInstance(askEl).hide();
  });
}

/** Order detail: delivered → confirm received → completed */
function initOrderReceive() {
  var askEl = document.getElementById('gn-modal-receive-order');
  var confirmBtn = document.querySelector('.js-order-receive-confirm');
  if (!askEl || !confirmBtn || !window.bootstrap) return;

  confirmBtn.addEventListener('click', function () {
    markOrderReceived();
    bootstrap.Modal.getOrCreateInstance(askEl).hide();
  });
}

function markOrderReceived() {
  document.querySelectorAll('.gn-order-stepper__item').forEach(function (el) {
    el.classList.add('is-done');
  });

  var pill = document.querySelector('.js-order-status-pill');
  if (pill) {
    pill.className = 'gn-order-status-pill js-order-status-pill is-completed';
    pill.textContent = 'Đã nhận';
  }

  var receiveBtn = document.querySelector('.js-order-receive-open');
  if (receiveBtn) receiveBtn.remove();
}

/**
 * Profile avatar: file input → local preview
 */
function initProfileAvatar() {
  var input = document.querySelector('.js-profile-avatar-input');
  var img = document.querySelector('.js-profile-avatar-img');
  var initials = document.querySelector('.js-profile-avatar-initials');
  if (!input || !img) return;

  input.addEventListener('change', function () {
    var file = input.files && input.files[0];
    if (!file || !file.type.startsWith('image/')) return;

    var url = URL.createObjectURL(file);
    img.onload = function () {
      URL.revokeObjectURL(url);
    };
    img.src = url;
    img.classList.remove('d-none');
    if (initials) initials.classList.add('d-none');
  });
}
/**
 * Floating cluster: scroll to top / #main-content
 */
function initFloatTop() {
  document.querySelectorAll('.js-float-top').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = document.getElementById('main-content');
      if (target && typeof target.scrollIntoView === 'function') {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });
}

/**
 * Mobile: expand/collapse contact cluster so it does not cover product grid
 */
function initFloatToggle() {
  var root = document.getElementById('gn-float');
  var btn = document.getElementById('gn-float-toggle');
  if (!root || !btn) return;

  btn.addEventListener('click', function () {
    var open = root.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.setAttribute('aria-label', open ? 'Đóng liên hệ nhanh' : 'Mở liên hệ nhanh');
  });
}

/**
 * Parse "dd/mm/yy, hh:mm:ss" or "dd/mm/yyyy hh/mm/ss" → Date (local)
 */
function parseCountdownDate(raw) {
  if (!raw) return null;
  var parts = String(raw)
    .trim()
    .split(/[,\s]+/)
    .filter(Boolean);
  if (parts.length < 2) return null;

  var d = parts[0].split(/[\/\-]/);
  var t = parts[1].split(/[\/:]/);
  if (d.length < 3 || t.length < 3) return null;

  var day = parseInt(d[0], 10);
  var month = parseInt(d[1], 10) - 1;
  var year = parseInt(d[2], 10);
  if (year < 100) year += 2000;

  var hour = parseInt(t[0], 10);
  var min = parseInt(t[1], 10);
  var sec = parseInt(t[2], 10);
  if ([day, month, year, hour, min, sec].some(function (n) {
    return Number.isNaN(n);
  })) {
    return null;
  }

  var date = new Date(year, month, day, hour, min, sec);
  return Number.isNaN(date.getTime()) ? null : date;
}

function pad2(n) {
  return n < 10 ? '0' + n : String(n);
}

function initCountdowns() {
  document.querySelectorAll('.countdown-time[data-countdown-date]').forEach(function (el) {
    var end = parseCountdownDate(el.getAttribute('data-countdown-date'));
    if (!end) return;

    var hEl = el.querySelector('[data-countdown="h"]');
    var mEl = el.querySelector('[data-countdown="m"]');
    var sEl = el.querySelector('[data-countdown="s"]');
    if (!hEl || !mEl || !sEl) return;

    function tick() {
      var diff = end.getTime() - Date.now();
      if (diff <= 0) {
        hEl.textContent = '00';
        mEl.textContent = '00';
        sEl.textContent = '00';
        return false;
      }

      var totalSec = Math.floor(diff / 1000);
      var hours = Math.floor(totalSec / 3600);
      var mins = Math.floor((totalSec % 3600) / 60);
      var secs = totalSec % 60;

      // Cap display at 99 hours for 2-digit UI (ponytail: upgrade to days if needed)
      if (hours > 99) hours = 99;

      hEl.textContent = pad2(hours);
      mEl.textContent = pad2(mins);
      sEl.textContent = pad2(secs);
      return true;
    }

    if (!tick()) return;
    var timerId = setInterval(function () {
      if (!tick()) clearInterval(timerId);
    }, 1000);
  });
}

/**
 * Seamless horizontal marquee (clone set once, xPercent ±50 loop)
 * reverse: true → content moves left → right
 */
function initInfiniteMarquee(track, viewport, pxPerSec, reverse) {
  if (!window.gsap || !track || !viewport) return;

  var originals = Array.prototype.slice.call(track.children);
  if (!originals.length) return;

  originals.forEach(function (item) {
    var clone = item.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    track.appendChild(clone);
  });

  var mm = gsap.matchMedia();
  mm.add('(prefers-reduced-motion: no-preference)', function () {
    var tween = null;

    function play() {
      var w = track.scrollWidth / 2;
      if (w <= 0) return;
      if (tween) tween.kill();

      var fromX = reverse ? -50 : 0;
      var toX = reverse ? 0 : -50;
      gsap.set(track, { x: 0, xPercent: fromX });
      tween = gsap.fromTo(
        track,
        { xPercent: fromX },
        {
          xPercent: toX,
          duration: w / pxPerSec,
          ease: 'none',
          repeat: -1
        }
      );
    }

    function onEnter() {
      if (tween) tween.pause();
    }

    function onLeave() {
      if (tween) tween.resume();
    }

    function onResize() {
      var progress = tween ? tween.progress() : 0;
      play();
      if (tween) tween.progress(progress);
    }

    play();
    viewport.addEventListener('mouseenter', onEnter);
    viewport.addEventListener('mouseleave', onLeave);
    window.addEventListener('resize', onResize);

    return function () {
      viewport.removeEventListener('mouseenter', onEnter);
      viewport.removeEventListener('mouseleave', onLeave);
      window.removeEventListener('resize', onResize);
      if (tween) tween.kill();
      gsap.set(track, { clearProps: 'x,xPercent' });
    };
  });
}

/**
 * Category row: gentle infinite marquee + hover accent (desktop pointer)
 */
function initCatsGsap() {
  if (!window.gsap) return;

  var track = document.getElementById('gn-cats-track');
  var viewport = track && track.closest('.gn-cats__viewport');
  if (!track || !viewport) return;

  initInfiniteMarquee(track, viewport, 36);

  var mm = gsap.matchMedia();

  // Hover: scale media + accent title (fine pointer only)
  mm.add('(hover: hover) and (pointer: fine)', function () {
    var cleanups = [];
    var items = track.querySelectorAll('.gn-cats__item');

    items.forEach(function (item) {
      var media = item.querySelector('.gn-cats__media');
      var title = item.querySelector('.gn-cats__title');
      if (!media || !title) return;

      function onEnter() {
        gsap.to(media, { scale: 1.05, duration: 0.35, ease: 'power2.out', overwrite: 'auto' });
        gsap.to(title, { color: '#c0603f', duration: 0.25, overwrite: 'auto' });
      }

      function onLeave() {
        gsap.to(media, { scale: 1, duration: 0.35, ease: 'power2.out', overwrite: 'auto' });
        gsap.to(title, { color: '#006837', duration: 0.25, overwrite: 'auto' });
      }

      item.addEventListener('mouseenter', onEnter);
      item.addEventListener('mouseleave', onLeave);
      cleanups.push(function () {
        item.removeEventListener('mouseenter', onEnter);
        item.removeEventListener('mouseleave', onLeave);
        gsap.set([media, title], { clearProps: 'scale,color' });
      });
    });

    return function () {
      cleanups.forEach(function (fn) {
        fn();
      });
    };
  });
}

function initBrandsMarquee() {
  var track = document.getElementById('gn-brands-track');
  var viewport = track && track.closest('.gn-brands__viewport');
  initInfiniteMarquee(track, viewport, 48);
}

function initReviewsMarquee() {
  var track = document.getElementById('gn-reviews-track');
  var viewport = track && track.closest('.gn-reviews__viewport');
  initInfiniteMarquee(track, viewport, 40, true);
}

// Product listing: reset group checkboxes, sync label weight, submit the
// native Shopify filter form (collection.filters performs the actual filtering)
function initProductFilters() {
  document.querySelectorAll('[data-gn-filter-reset]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = document.getElementById(btn.getAttribute('data-gn-filter-reset'));
      if (!panel) return;
      var form = btn.closest('form.gn-filter');
      panel.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
        input.checked = false;
        var label = input.nextElementSibling;
        if (label) label.classList.remove('is-checked');
      });
      if (form) form.submit();
    });
  });

  document.querySelectorAll('.gn-filter__check .form-check-input:not([data-gn-price-bucket])').forEach(function (input) {
    input.addEventListener('change', function () {
      var label = input.nextElementSibling;
      if (label) label.classList.toggle('is-checked', input.checked);

      var form = input.closest('form.gn-filter');
      if (!form) return;

      form.submit();
    });
  });

  // Price filter: fixed ranges rendered as checkboxes (radio-like — only one
  // active at a time, since the underlying price_range filter is a single
  // gte/lte pair). Checking a bucket writes its range into the two hidden
  // inputs and submits; unchecking clears them.
  document.querySelectorAll('form.gn-filter').forEach(function (form) {
    var buckets = form.querySelectorAll('[data-gn-price-bucket]');
    var gteInput = form.querySelector('[data-gn-price-gte]');
    var lteInput = form.querySelector('[data-gn-price-lte]');
    if (!buckets.length || !gteInput || !lteInput) return;

    buckets.forEach(function (bucket) {
      bucket.addEventListener('change', function () {
        var label = bucket.nextElementSibling;
        buckets.forEach(function (other) {
          if (other !== bucket) {
            other.checked = false;
            var otherLabel = other.nextElementSibling;
            if (otherLabel) otherLabel.classList.remove('is-checked');
          }
        });
        if (label) label.classList.toggle('is-checked', bucket.checked);

        if (bucket.checked) {
          gteInput.value = bucket.getAttribute('data-gte') || '';
          lteInput.value = bucket.getAttribute('data-lte') || '';
        } else {
          gteInput.value = '';
          lteInput.value = '';
        }
        gteInput.disabled = gteInput.value === '';
        lteInput.disabled = lteInput.value === '';
        form.submit();
      });
    });
  });
}

// Product listing: sort dropdown label + native Shopify sort_by navigation,
// preserving whatever filters are currently active in the URL
function initProductSort() {
  document.querySelectorAll('.gn-product-sort__menu .dropdown-item').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var menu = btn.closest('.dropdown-menu');
      var toggle = menu && menu.previousElementSibling;
      var label = toggle && toggle.querySelector('.gn-product-sort__label');
      if (label) label.textContent = btn.textContent.trim();
      menu.querySelectorAll('.dropdown-item').forEach(function (el) {
        el.classList.toggle('active', el === btn);
      });
      var dropdown = window.bootstrap && bootstrap.Dropdown.getInstance(toggle);
      if (dropdown) dropdown.hide();

      var sortValue = btn.getAttribute('data-sort');
      if (!sortValue) return;
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', sortValue);
      params.delete('page');
      window.location.search = params.toString();
    });
  });
}

// PDP: thumbnail → main image (fade out → swap → fade in)
function initPdpGallery() {
  var root = document.querySelector('[data-pdp-gallery]');
  if (!root) return;
  var main = root.querySelector('[data-pdp-main]');
  if (!main) return;
  var busy = false;
  var fadeMs = 200;

  root.querySelectorAll('[data-pdp-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var src = btn.getAttribute('data-src');
      if (!src || src === main.getAttribute('src') || busy) return;

      root.querySelectorAll('[data-pdp-thumb]').forEach(function (el) {
        var on = el === btn;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      busy = true;
      main.classList.add('is-fading');

      window.setTimeout(function () {
        main.src = src;

        function show() {
          // Next frame so opacity 0 paints before fade-in
          requestAnimationFrame(function () {
            main.classList.remove('is-fading');
            busy = false;
          });
        }

        if (main.complete) show();
        else main.addEventListener('load', show, { once: true });
      }, fadeMs);
    });
  });
}

// Auth modals: live "confirm password" match check, blocks submit on mismatch
function initPasswordConfirmCheck() {
  document.querySelectorAll('[data-pdp-confirm-of]').forEach(function (confirmInput) {
    var passInput = document.getElementById(confirmInput.getAttribute('data-pdp-confirm-of'));
    var errorEl = confirmInput.closest('.gn-auth-field').querySelector('.gn-auth-field__error');
    if (!passInput || !errorEl) return;
    var defaultMessage = errorEl.textContent;

    function validate() {
      var mismatch = confirmInput.value.length > 0 && confirmInput.value !== passInput.value;
      confirmInput.classList.toggle('is-invalid', mismatch);
      errorEl.textContent = defaultMessage;
      errorEl.hidden = !mismatch;
      return !mismatch;
    }

    confirmInput.addEventListener('input', validate);
    passInput.addEventListener('input', function () {
      if (confirmInput.value.length > 0) validate();
    });

    var form = confirmInput.closest('form');
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!validate()) {
          e.preventDefault();
          confirmInput.focus();
        }
      });
    }
  });
}

// Auth modals: reopen automatically after a full-page submit that came back with errors
function initAuthModalAutoShow() {
  if (!window.bootstrap) return;
  document.querySelectorAll('.modal[data-auto-show="true"]').forEach(function (el) {
    var modal = bootstrap.Modal.getOrCreateInstance(el);
    modal.show();
    var firstError = el.querySelector('.gn-auth-field__error:not([hidden])');
    if (firstError) {
      el.addEventListener(
        'shown.bs.modal',
        function () {
          var field = firstError.closest('.gn-auth-field') && firstError.closest('.gn-auth-field').querySelector('input');
          if (field) field.focus();
        },
        { once: true }
      );
    }
  });
}

// PDP: option pills (Quy cách...) — select state only, cart wiring comes later
function initPdpOptions() {
  document.querySelectorAll('[data-pdp-option-group]').forEach(function (group) {
    group.querySelectorAll('[data-pdp-option-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        group.querySelectorAll('[data-pdp-option-value]').forEach(function (el) {
          el.classList.remove('is-active');
        });
        btn.classList.add('is-active');
      });
    });
  });
}

// PDP: qty steppers stay in sync across hero + sticky
function initPdpQty() {
  var groups = document.querySelectorAll('[data-pdp-qty]');
  if (!groups.length) return;
  var qty = 1;

  function render() {
    groups.forEach(function (g) {
      var el = g.querySelector('[data-pdp-qty-value]');
      if (el) el.textContent = String(qty);
    });
  }

  groups.forEach(function (g) {
    var dec = g.querySelector('[data-pdp-qty-dec]');
    var inc = g.querySelector('[data-pdp-qty-inc]');
    if (dec) {
      dec.addEventListener('click', function () {
        if (qty > 1) qty -= 1;
        render();
      });
    }
    if (inc) {
      inc.addEventListener('click', function () {
        qty += 1;
        render();
      });
    }
  });
}

// Shared: format an amount for optimistic cart updates. Shopify Markets is the single
// source of currency + exchange rate — this does NOT convert anything, it only formats
// an amount Shopify already returned in the active presentment currency. `currency` is
// the ISO code from the Ajax Cart response (cart.currency) or [data-cart-currency].
function gnFormatMoney(cents, currency) {
  var amount = (parseFloat(cents) || 0) / 100;
  var code = currency || 'AUD';
  try {
    return new Intl.NumberFormat(document.documentElement.lang || undefined, {
      style: 'currency',
      currency: code
    }).format(amount);
  } catch (e) {
    return amount.toLocaleString() + ' ' + code;
  }
}

// Shared: swap header cart badge + dropdown preview from a re-rendered header section,
// without touching the toggle buttons themselves (keeps Bootstrap's dropdown bindings intact).
function applyCartHeaderFragment(newDoc) {
  ['gn-cart-toggle-desktop', 'gn-cart-toggle-mobile'].forEach(function (toggleId) {
    var liveToggle = document.getElementById(toggleId);
    var newToggle = newDoc.getElementById(toggleId);
    if (!liveToggle || !newToggle) return;

    var liveBadge = liveToggle.querySelector('.gn-header__cart-badge');
    var newBadge = newToggle.querySelector('.gn-header__cart-badge');
    if (liveBadge && newBadge) liveBadge.textContent = newBadge.textContent;
    var newLabel = newToggle.getAttribute('aria-label');
    if (newLabel) liveToggle.setAttribute('aria-label', newLabel);

    var liveDropdown = document.querySelector('.dropdown-menu[aria-labelledby="' + toggleId + '"]');
    var newDropdown = newDoc.querySelector('.dropdown-menu[aria-labelledby="' + toggleId + '"]');
    if (!liveDropdown || !newDropdown) return;

    var liveMeta = liveDropdown.querySelector('.gn-dropdown__meta');
    var newMeta = newDropdown.querySelector('.gn-dropdown__meta');
    if (liveMeta && newMeta) liveMeta.textContent = newMeta.textContent;

    var liveBody = liveDropdown.querySelector('.gn-dropdown__body');
    var newBody = newDropdown.querySelector('.gn-dropdown__body');
    if (liveBody && newBody) liveBody.innerHTML = newBody.innerHTML;

    var liveTotal = liveDropdown.querySelector('.gn-dropdown__total strong');
    var newTotal = newDropdown.querySelector('.gn-dropdown__total strong');
    if (liveTotal && newTotal) liveTotal.textContent = newTotal.textContent;
  });
}

function refreshHeaderCart() {
  fetch(window.location.pathname + '?sections=header&_=' + Date.now(), { cache: 'no-store' })
    .then(function (res) {
      return res.json();
    })
    .then(function (data) {
      var doc = new DOMParser().parseFromString(data.header, 'text/html');
      applyCartHeaderFragment(doc);
    })
    .catch(function () {});
}

function gnEscapeHtml(value) {
  return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
  });
}

function gnCartImageUrl(url, width) {
  if (!url) return '';
  return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
}

// Builds one <li> exactly matching the Liquid markup in sections/cart-page.liquid, from the
// same line-item shape the Ajax Cart API returns (/cart.js, /cart/add.js, /cart/change.js).
function gnBuildCartItemHtml(item, index, currency) {
  var title = gnEscapeHtml(item.product_title);
  var variantSuffix = item.variant_title && item.variant_title !== 'Default Title' ? ' — ' + gnEscapeHtml(item.variant_title) : '';
  var hasLineDiscount = item.original_line_price !== item.final_line_price;
  var hasUnitDiscount = item.price !== item.final_price;
  var img = gnCartImageUrl(item.image, 254);

  return (
    '<li class="gn-cart-item" data-cart-item data-cart-variant-id="' +
    item.id +
    '" data-cart-unit-price="' +
    item.final_price +
    '">' +
    '<div class="gn-cart-item__row d-flex align-items-center gap-3">' +
    '<div class="form-check gn-cart-item__check m-0 p-0"><input class="form-check-input gn-cart-check" type="checkbox" id="cart-' +
    (index + 1) +
    '" checked aria-label="Chọn ' +
    title +
    '"></div>' +
    '<a class="gn-cart-item__thumb flex-shrink-0" href="' +
    item.url +
    '"><img src="' +
    img +
    '" alt="' +
    title +
    '" width="127" height="127" loading="eager" decoding="async"></a>' +
    '<div class="gn-cart-item__body d-flex flex-column justify-content-between flex-grow-1 min-w-0">' +
    '<div class="gn-cart-item__info d-flex flex-column gap-2 mb-2 mb-lg-0">' +
    '<p class="gn-cart-item__brand text-uppercase mb-0">' +
    gnEscapeHtml(item.vendor) +
    '</p>' +
    '<a class="gn-cart-item__name text-decoration-none" href="' +
    item.url +
    '">' +
    title +
    variantSuffix +
    '</a>' +
    (hasLineDiscount ? '<div class="gn-cart-item__badges d-flex align-items-center gap-2 flex-wrap"><span class="gn-cart-badge">Giảm giá</span></div>' : '') +
    '</div>' +
    '<div class="gn-cart-item__foot d-flex align-items-center justify-content-between gap-3 flex-wrap">' +
    '<div class="gn-cart-item__prices d-flex align-items-center gap-2 flex-wrap"><span class="gn-cart-item__price">' +
    gnFormatMoney(item.final_price, currency) +
    '</span>' +
    (hasUnitDiscount ? '<span class="gn-cart-item__price-old">' + gnFormatMoney(item.price, currency) + '</span>' : '') +
    '</div>' +
    '<div class="gn-pdp-qty gn-cart-item__qty d-inline-flex align-items-center justify-content-center gap-3" data-cart-qty role="group" aria-label="Số lượng ' +
    title +
    '">' +
    '<button class="gn-pdp-qty__btn" type="button" data-cart-qty-dec aria-label="Giảm số lượng"><i class="fa-solid fa-minus" aria-hidden="true"></i></button><span class="gn-pdp-qty__value" data-cart-qty-value>' +
    item.quantity +
    '</span>' +
    '<button class="gn-pdp-qty__btn" type="button" data-cart-qty-inc aria-label="Tăng số lượng"><i class="fa-solid fa-plus" aria-hidden="true"></i></button>' +
    '</div>' +
    '</div>' +
    '</div>' +
    '<button class="gn-cart-item__remove" type="button" data-cart-remove aria-label="Xóa ' +
    title +
    '"><i class="fa-solid fa-xmark" aria-hidden="true"></i></button>' +
    '</div>' +
    '</li>'
  );
}

// Re-renders the cart page's list + summary from the Ajax Cart API's own JSON (the response
// /cart/change.js already gives us) instead of Shopify's Section Rendering API — that API
// reliably returns a null "main" section on this store's /cart route (verified independently,
// not a caching/timing artifact), so it can't be used to reconcile the page without a full
// reload. This keeps the SPA-like update working without ever depending on it.
function gnRenderCartFromJson(cart) {
  var root = document.querySelector('[data-cart-root]');
  if (!root) return;
  var currency = (cart && cart.currency) || root.getAttribute('data-cart-currency');

  var titleEl = root.querySelector('.gn-cart__title');
  if (titleEl) titleEl.textContent = 'Giỏ hàng (' + cart.item_count + ')';

  var row = root.querySelector('.row.g-4.g-xl-5.align-items-start');
  var emptyBlock = root.querySelector('.gn-cart-empty');

  if (cart.item_count === 0) {
    if (row) row.remove();
    if (!emptyBlock) {
      var container = root.querySelector('.container');
      var shopUrl = root.getAttribute('data-cart-shop-url') || '/';
      var empty = document.createElement('div');
      empty.className = 'gn-cart-empty text-center py-5';
      empty.innerHTML =
        '<p class="gn-cart-empty__text mb-4">Giỏ hàng của bạn đang trống.</p><a class="gn-pdp-btn gn-pdp-btn--primary text-decoration-none" href="' +
        shopUrl +
        '">Tiếp tục mua sắm</a>';
      if (container) container.appendChild(empty);
    }
    return;
  }

  if (emptyBlock) emptyBlock.remove();

  var list = root.querySelector('.gn-cart-list');
  if (list) {
    list.innerHTML = cart.items
      .map(function (item, i) {
        return gnBuildCartItemHtml(item, i, currency);
      })
      .join('');
  }

  var subtotalEl = root.querySelector('[data-cart-subtotal]');
  if (subtotalEl) subtotalEl.textContent = gnFormatMoney(cart.items_subtotal_price, currency);

  var totalEl = root.querySelector('[data-cart-total]');
  if (totalEl) totalEl.textContent = gnFormatMoney(cart.total_price, currency);

  var summaryRows = root.querySelector('.gn-cart-summary__rows');
  var saveRow = summaryRows ? summaryRows.querySelector('.gn-cart-summary__save') : null;
  if (cart.total_discount > 0) {
    if (saveRow) {
      saveRow.textContent = '−' + gnFormatMoney(cart.total_discount, currency);
    } else if (summaryRows) {
      var saveRowWrap = document.createElement('div');
      saveRowWrap.className = 'gn-cart-summary__row d-flex justify-content-between gap-2';
      saveRowWrap.innerHTML = '<dt class="mb-0">Tiết kiệm</dt><dd class="gn-cart-summary__save mb-0">−' + gnFormatMoney(cart.total_discount, currency) + '</dd>';
      summaryRows.appendChild(saveRowWrap);
    }
  } else if (saveRow) {
    var staleRow = saveRow.closest('.gn-cart-summary__row');
    if (staleRow) staleRow.remove();
  }
}

// Cart page: real qty change / remove via Ajax Cart API, re-renders itself + header via Section Rendering API.
// Delegated on document so it only ever needs to bind once, even though the cart root gets
// replaced wholesale on every reconcile (a per-node rebind here was the source of a stacking-listener bug).
function initCartPage() {
  if (!document.querySelector('[data-cart-root]')) return;
  if (window.__gnCartPageBound) return;
  window.__gnCartPageBound = true;

  function bumpHeaderBadge(delta) {
    document.querySelectorAll('.gn-header__cart-badge').forEach(function (el) {
      var n = (parseInt(el.textContent, 10) || 0) + delta;
      el.textContent = String(n < 0 ? 0 : n);
    });
  }

  // Optimistic subtotal/total: sums each line's unit price (already discount-aware, from
  // Liquid) × its currently-displayed quantity. Corrected moments later by reconcile()'s
  // real server totals — this just avoids the summary box sitting frozen during that wait.
  function recalcSummary() {
    var root = document.querySelector('[data-cart-root]');
    if (!root) return;
    var currency = root.getAttribute('data-cart-currency');
    var cents = 0;
    root.querySelectorAll('[data-cart-item]').forEach(function (li) {
      var unitPrice = parseFloat(li.getAttribute('data-cart-unit-price')) || 0;
      var qtyEl = li.querySelector('[data-cart-qty-value]');
      var qty = (qtyEl && parseInt(qtyEl.textContent, 10)) || 0;
      cents += unitPrice * qty;
    });
    var subtotalEl = root.querySelector('[data-cart-subtotal]');
    var totalEl = root.querySelector('[data-cart-total]');
    if (subtotalEl) subtotalEl.textContent = gnFormatMoney(cents, currency);
    if (totalEl) totalEl.textContent = gnFormatMoney(cents, currency);
  }

  function unlock(li) {
    li.removeAttribute('data-cart-busy');
    li.style.opacity = '';
    li.style.pointerEvents = '';
  }

  function unremove(li) {
    // Removal failed server-side after all — bring the row back rather than silently
    // losing it, and put its qty/summary contribution back too.
    unlock(li);
    li.hidden = false;
    var qtyEl = li.querySelector('[data-cart-qty-value]');
    var original = li.getAttribute('data-cart-qty-before-remove');
    if (qtyEl && original) qtyEl.textContent = original;
    bumpHeaderBadge(parseInt(original, 10) || 1);
    recalcSummary();
  }

  function changeItem(li, variantId, quantity, onError) {
    onError = onError || unlock;
    li.setAttribute('data-cart-busy', 'true');
    // Safety net: whatever goes wrong (network error, unexpected response shape, a
    // window.Shopify that isn't ready yet...), never leave a row permanently stuck
    // (or, for a failed removal, permanently hidden).
    var safety = window.setTimeout(function () {
      onError(li);
    }, 8000);

    try {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart/change.js failed');
          return res.json();
        })
        .then(function (cart) {
          window.clearTimeout(safety);
          // /cart/change.js already returns the full, authoritative cart — build the list
          // and totals from that JSON instead of a page reload or the section-rendering
          // route (which reliably 500s as { main: null } on this store's /cart route).
          gnRenderCartFromJson(cart);
          refreshHeaderCart();
        })
        .catch(function () {
          window.clearTimeout(safety);
          onError(li);
        });
    } catch (err) {
      window.clearTimeout(safety);
      onError(li);
    }
  }

  document.addEventListener('click', function (e) {
    var li = e.target.closest('[data-cart-item]');
    if (!li || li.hasAttribute('data-cart-busy')) return;
    var variantId = li.getAttribute('data-cart-variant-id');
    var qtyEl = li.querySelector('[data-cart-qty-value]');
    var qty = (qtyEl && parseInt(qtyEl.textContent, 10)) || 1;

    if (e.target.closest('[data-cart-qty-dec]')) {
      if (qty <= 1) return;
      if (qtyEl) qtyEl.textContent = String(qty - 1);
      bumpHeaderBadge(-1);
      recalcSummary();
      changeItem(li, variantId, qty - 1);
    } else if (e.target.closest('[data-cart-qty-inc]')) {
      if (qtyEl) qtyEl.textContent = String(qty + 1);
      bumpHeaderBadge(1);
      recalcSummary();
      changeItem(li, variantId, qty + 1);
    } else if (e.target.closest('[data-cart-remove]')) {
      li.setAttribute('data-cart-qty-before-remove', String(qty));
      li.hidden = true;
      if (qtyEl) qtyEl.textContent = '0';
      bumpHeaderBadge(-qty);
      recalcSummary();
      changeItem(li, variantId, 0, unremove);
    }
  });
}

// PDP: add to cart / buy now — resolves selected variant from option pills, calls Ajax Cart API
function initPdpAddToCart() {
  var root = document.querySelector('[data-pdp-product]');
  if (!root) return;

  var variantsScript = document.querySelector('[data-pdp-variants]');
  var variants = [];
  try {
    variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
  } catch (e) {}
  var defaultVariantId = root.getAttribute('data-pdp-default-variant');

  function selectedVariantId() {
    var groups = document.querySelectorAll('[data-pdp-option-group]');
    if (!groups.length) return defaultVariantId ? Number(defaultVariantId) : null;
    var values = [];
    groups.forEach(function (g) {
      var active = g.querySelector('.is-active[data-pdp-option-value]');
      values.push(active ? active.getAttribute('data-pdp-option-value') : null);
    });
    var match = variants.filter(function (v) {
      return [v.option1, v.option2, v.option3].every(function (opt, i) {
        return values[i] === undefined || values[i] === null || opt === values[i];
      });
    })[0];
    return match ? match.id : defaultVariantId ? Number(defaultVariantId) : null;
  }

  function currentQty() {
    var el = document.querySelector('[data-pdp-qty-value]');
    var n = el ? parseInt(el.textContent, 10) : 1;
    return !n || n < 1 ? 1 : n;
  }

  function showError(message) {
    document.querySelectorAll('[data-pdp-cart-error]').forEach(function (el) {
      el.textContent = message || '';
      el.hidden = !message;
    });
  }

  function addToCart() {
    var variantId = selectedVariantId();
    if (!variantId) {
      showError('Vui lòng chọn đầy đủ tùy chọn sản phẩm.');
      return Promise.reject();
    }
    showError('');
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: currentQty() }] })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || 'Không thể thêm vào giỏ hàng.');
        return data;
      });
    });
  }

  document.querySelectorAll('[data-pdp-add-to-cart]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var original = btn.textContent;
      btn.disabled = true;
      addToCart()
        .then(function () {
          refreshHeaderCart();
          btn.textContent = 'Đã thêm ✓';
          window.setTimeout(function () {
            btn.textContent = original;
            btn.disabled = false;
          }, 1500);
        })
        .catch(function (err) {
          btn.disabled = false;
          if (err) showError(err.message || 'Không thể thêm vào giỏ hàng.');
        });
    });
  });

  document.querySelectorAll('[data-pdp-buy-now]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.disabled = true;
      addToCart()
        .then(function () {
          window.location.href = window.Shopify.routes.root + 'checkout';
        })
        .catch(function (err) {
          btn.disabled = false;
          if (err) showError(err.message || 'Không thể thêm vào giỏ hàng.');
        });
    });
  });
}

// Product cards: hover CTA adds the selected/default variant directly to cart.
function initProductCardAddToCart() {
  document.querySelectorAll('[data-product-card-add-to-cart]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (btn.disabled) return;

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Đang thêm...';

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data.description || data.message || 'Không thể thêm vào giỏ hàng.');
            return data;
          });
        })
        .then(function () {
          refreshHeaderCart();
          btn.textContent = 'Đã thêm ✓';
          window.setTimeout(function () {
            btn.textContent = original;
            btn.disabled = false;
          }, 1500);
        })
        .catch(function () {
          btn.textContent = 'Lỗi';
          window.setTimeout(function () {
            btn.textContent = original;
            btn.disabled = false;
          }, 1500);
        });
    });
  });
}

// Payment: highlight selected method row
function initPayMethods() {
  var radios = document.querySelectorAll('[data-pay-method]');
  if (!radios.length) return;

  function sync() {
    radios.forEach(function (radio) {
      var row = radio.closest('.gn-pay-method');
      if (row) row.classList.toggle('is-active', radio.checked);
    });
  }

  radios.forEach(function (radio) {
    radio.addEventListener('change', sync);
  });
  sync();
}

// Payment: submit → status page (demo: ?status=fail for failure)
function initPayForm() {
  var form = document.getElementById('gn-pay-form');
  if (!form) return;
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    window.location.href = 'payment-status.html';
  });
}

// Auth modals: password toggle + dial + OTP + client validation
function initAuthModals() {
  var validateForm = window.GnValidate.validateForm;
  var bindFieldClear = window.GnValidate.bindFieldClear;
  var setFieldError = window.GnValidate.setFieldError;

  document.querySelectorAll('.js-auth-pass-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = document.getElementById(btn.getAttribute('data-target'));
      if (!input) return;
      var show = input.type === 'password';
      input.type = show ? 'text' : 'password';
      btn.setAttribute('aria-label', show ? 'Ẩn mật khẩu' : 'Hiện mật khẩu');
      var icon = btn.querySelector('i');
      if (icon) {
        icon.classList.toggle('fa-eye', !show);
        icon.classList.toggle('fa-eye-slash', show);
      }
    });
  });

  document.querySelectorAll('.gn-auth-phone__menu .dropdown-item[data-dial]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var dropdown = btn.closest('.gn-auth-phone__dropdown');
      if (!dropdown) return;
      var flagCode = btn.getAttribute('data-flag');
      var dial = btn.getAttribute('data-dial');
      var flag = dropdown.querySelector('.js-auth-dial-flag');
      var code = dropdown.querySelector('.js-auth-dial-code');
      var hidden = dropdown.querySelector('.js-auth-dial-input');
      if (flag && flagCode) {
        flag.className = 'fi fi-' + flagCode + ' gn-auth-phone__flag js-auth-dial-flag';
      }
      if (code && dial) code.textContent = dial;
      if (hidden && dial) hidden.value = dial;
    });
  });

  document.querySelectorAll('.gn-auth-otp').forEach(function (group) {
    var digits = group.querySelectorAll('.gn-auth-otp__digit');
    digits.forEach(function (input, i) {
      input.addEventListener('input', function () {
        input.value = input.value.replace(/\D/g, '').slice(-1);
        if (input.value && digits[i + 1]) digits[i + 1].focus();
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Backspace' && !input.value && digits[i - 1]) {
          digits[i - 1].focus();
        }
      });
      input.addEventListener('paste', function (e) {
        e.preventDefault();
        var paste = (e.clipboardData.getData('text') || '').replace(/\D/g, '').slice(0, digits.length);
        paste.split('').forEach(function (ch, j) {
          if (digits[j]) digits[j].value = ch;
        });
        var focusIdx = Math.min(paste.length, digits.length - 1);
        if (digits[focusIdx]) digits[focusIdx].focus();
      });
    });
  });

  var forgotForm = document.getElementById('gn-forgot-form');
  if (forgotForm) {
    bindFieldClear(forgotForm);
    forgotForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!validateForm(forgotForm) || !window.bootstrap) return;
      var forgotEl = document.getElementById('gn-modal-forgot');
      var otpEl = document.getElementById('gn-modal-forgot-otp');
      if (!forgotEl || !otpEl) return;
      forgotEl.addEventListener(
        'hidden.bs.modal',
        function onHidden() {
          forgotEl.removeEventListener('hidden.bs.modal', onHidden);
          bootstrap.Modal.getOrCreateInstance(otpEl).show();
          var first = otpEl.querySelector('.gn-auth-otp__digit');
          if (first) first.focus();
        },
        { once: true }
      );
      bootstrap.Modal.getOrCreateInstance(forgotEl).hide();
    });
  }

  ['gn-login-form', 'gn-register-form'].forEach(function (id) {
    var form = document.getElementById(id);
    if (!form) return;
    bindFieldClear(form);
    form.addEventListener('submit', function (e) {
      if (!validateForm(form)) e.preventDefault();
    });
  });

  // OTP forgot → open set-new-password modal
  var otpForm = document.getElementById('gn-forgot-otp-form');
  if (otpForm) {
    bindFieldClear(otpForm);
    otpForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!validateForm(otpForm) || !window.bootstrap) return;
      var otpEl = document.getElementById('gn-modal-forgot-otp');
      var setPwEl = document.getElementById('gn-modal-set-password');
      if (!otpEl || !setPwEl) return;
      otpEl.addEventListener(
        'hidden.bs.modal',
        function () {
          bootstrap.Modal.getOrCreateInstance(setPwEl).show();
        },
        { once: true }
      );
      bootstrap.Modal.getOrCreateInstance(otpEl).hide();
    });
  }

  // Set new password — validate match
  var setPwForm = document.getElementById('gn-set-password-form');
  if (setPwForm) {
    bindFieldClear(setPwForm);
    setPwForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!validateForm(setPwForm)) return;
      var pw = document.getElementById('gn-set-password-new');
      var confirm = document.getElementById('gn-set-password-confirm');
      if (pw && confirm && pw.value !== confirm.value) {
        setFieldError(confirm, 'Mật khẩu xác nhận không khớp');
        confirm.focus();
      }
    });
  }
}
